<div id="audit-print">
  <h2>Template: {{ auditName }}</h2>
  @if (auditPrint$ | async; as aps) {
    <div class="ow-fluid">
      @for (ap of aps; track ap) {
        <div class="row-fluid">
          <div class="acronyms-level">
            <h3 class="acronyms-name">
              <strong>Publication</strong>: {{ ap.acronym }}
            </h3>
            <div class="acronym-level">
              @for (tp of ap.topics; track tp) {
                <div>
                  <div>
                    <h4>Topic: {{ tp.topic }}</h4>
                    <div class="table">
                      @for (rb of tp.rulebooks; track rb) {
                        <div>
                          <div class="row-fluid table-header">
                            <div>{{ rb.rbName }}</div>
                            <div class="row-end">
                              <input
                                type="checkbox"
                                [checked]="rb.checkNa"
                              />N/A
                            </div>
                          </div>
                          <br />
                          @if (!rb.checkNa) {
                            <div>
                              @for (apq of rb.appSect; track apq) {
                                <div class="table-body">
                                  @if (apq.rbSectNum == 0) {
                                    <div class="row-fluid">
                                      <div class="c1">Rulebook Question</div>
                                      <div
                                        class="c3"
                                        [innerHTML]="apq.question"
                                      ></div>
                                      <div class="row-end">
                                        <strong>Answer:</strong>
                                        {{ apq.answerQ }}
                                      </div>
                                      @if (
                                        apq.exemption != null &&
                                        apq.answerQ != "N"
                                      ) {
                                        <div>
                                          <div class="c1">
                                            Excemption Question
                                          </div>
                                          <div
                                            class="c3"
                                            [innerHTML]="apq.exemption"
                                          ></div>
                                          <div class="row-end">
                                            <strong>Answer:</strong>
                                            {{ apq.answerE }}
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (apq.rbSectNum > 0) {
                                    <div class="row-fluid">
                                      <div class="c1">
                                        Section {{ apq.rbSectNum }}
                                      </div>
                                      <div
                                        class="c3"
                                        [innerHTML]="apq.question"
                                      ></div>
                                      <div class="row-end">
                                        <strong>Answer:</strong>
                                        {{ apq.answerQ }}
                                      </div>
                                      @if (
                                        apq.exemption != null &&
                                        apq.answerQ != "N"
                                      ) {
                                        <div>
                                          <div class="c1">
                                            Excemption Question
                                          </div>
                                          <div
                                            class="c3"
                                            [innerHTML]="apq.exemption"
                                          ></div>
                                          <div class="row-end">
                                            <strong>Answer:</strong>
                                            {{ apq.answerE }}
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="audit-header">
  <div class="button-row">
    <button
      mat-button
      class="icon-only"
      matTooltip="refresh the data"
      matTooltipClass="tooltip2"
      (click)="reload()"
    >
      <mat-icon fontSet="material-icons-outlined">sync</mat-icon>
    </button>
    <button
      mat-button
      class="icon-only"
      (click)="printAudit()"
      matTooltip="Print audit - a record of how you answered all of the applicability screening questions."
      matTooltipClass="tooltip2"
    >
      <mat-icon fontSet="material-icons-outlined">local_printshop</mat-icon>
    </button>
    <button
      mat-button
      class="icon-only"
      matTooltip="Add/remove topics"
      matTooltipClass="tooltip2"
      (click)="onAddRulebook($event)"
    >
      <mat-icon>add_box</mat-icon>
    </button>
    <button
      mat-button
      class="icon-only"
      (click)="backToHome()"
      matTooltip="Back to RegApply home"
      matTooltipClass="tooltip2"
    >
      <mat-icon>west</mat-icon>
    </button>
  </div>
</div>

@if (rulebooks) {
  <div class="audit-content" fxLayout fxFlex>
    <div class="audit-rb" fxFlex="65">
      <div class="audit-rb-header">
        <ul class="nav nav-tabs">
          @for (ac of rulebooks; track ac) {
            <li>
              <a
                [routerLink]=""
                [class]="ac.acronym == selectedAcronym ? 'selected' : 'none'"
                (click)="onAcronymChange(ac.acronym)"
                >{{ ac.acronym }}({{ ac.releaseNum }})</a
              >
            </li>
          }
        </ul>
        <!--Audit Details (and its Actions menu) is hidden below 920px - this duplicate
        trigger, shown only in that range, keeps Actions reachable without it. Both
        buttons share the one #actionMenu defined below; Angular resolves template
        reference variables across the whole template regardless of declaration order. -->
        <div class="audit-detail-mobile-actions">
          <button
            mat-button
            class="reverse-icon-button"
            [matMenuTriggerFor]="actionMenu"
            #mobileMenuTrigger="matMenuTrigger"
            (click)="mobileMenuTrigger.openMenu()"
          >
            Actions<mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>
      @if (selectedAcronym !== "Custom") {
        @for (ac of rulebooks; track ac) {
          <div class="table-content">
            @if (ac.acronym == selectedAcronym) {
              <div class="active">
                @for (tp of ac.topics; track tp) {
                  <div class="widget-box">
                    <div class="widget-header">
                      <li>{{ tp.topic }}</li>
                      <span></span>
                    </div>
                    <div class="widget-body">
                      <table
                        class="table table-striped table-bordered table-hover"
                      >
                        <thead>
                          <tr>
                            <th class="t1">Rulebook</th>
                            <th class="t2 t2-lastsaved">Last Saved</th>
                            <th class="t3 t3-status">Applicability Status</th>
                            <th class="t3 t3-apply">
                              Apply<mat-icon
                                class="help-info"
                                (click)="openHelpInfo($event, 6)"
                                >info</mat-icon
                              >
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (rb of tp.rulebooks; track rb) {
                            <tr>
                              <td
                                class="t1 rbName"
                                (click)="
                                  onRbClick(rb.appKey, rb.rbName, rb.abridged)
                                "
                              >
                                <span
                                  [class.newRulebook]="
                                    rb.isNew && rb.status == 'Needs Review'
                                  "
                                  [matTooltip]="
                                    rb.isNew && rb.status == 'Needs Review'
                                      ? 'This is a new rulebook'
                                      : ''
                                  "
                                  matTooltipClass="tooltip2"
                                  >{{ rb.rbName }}</span
                                >
                                @if (rb.abridged) {
                                  <mat-icon
                                    matTooltip="Abridged Protocol"
                                    matTooltipClass="tooltip2"
                                    >info</mat-icon
                                  >
                                }
                                @if (rb.sigChangeUpdate) {
                                  <mat-icon
                                    fontSet="material-icons-outlined"
                                    class="sigChangeReview"
                                    matTooltip="Rulebook Significant Updates for Review"
                                    matTooltipClass="tooltip2"
                                    (click)="onReviewUpdate($event, rb.appKey, true)"
                                  >
                                    warning
                                  </mat-icon>
                                } @else if (rb.checkUpdate) {
                                  <mat-icon
                                    class="needsReview"
                                    matTooltip="Rulebook Updates for Review"
                                    matTooltipClass="tooltip2"
                                    (click)="onReviewUpdate($event, rb.appKey)"
                                  >
                                    flag
                                  </mat-icon>
                                }
                              </td>
                              <td class="t2 t2-lastsaved">
                                <span>{{ rb.dateModified | date: "yyyy-MM-dd" }}</span>
                              </td>
                              <td class="t3 t3-status">
                                <span
                                  class="rb-percent"
                                  [ngClass]="{
                                    complete: rb.status == 'Applicable',
                                    'not-applicable':
                                      rb.status == 'Not Applicable',
                                    needsReview: rb.status == 'Needs Review',
                                  }"
                                >
                                  {{ rb.status }}
                                </span>
                              </td>
                              <td class="t3 t3-apply">
                                <mat-checkbox
                                  class="topic-check"
                                  [(ngModel)]="rb.checkNa"
                                  [disabled]="isLoading || !editable"
                                  (change)="onCheckNaChange($event, rb.appKey)"
                                  >N/A</mat-checkbox
                                >
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
      @if (selectedAcronym === "Custom") {
        @for (ac of rulebooks; track ac) {
          <div class="table-content">
            @if (ac.acronym == selectedAcronym) {
              <div class="active">
                @for (tp of ac.topics; track tp) {
                  <div class="widget-box">
                    <div class="widget-header">
                      <li>
                        {{ tp.topic }}
                        <mat-icon
                          class="help-info"
                          matTooltip="This topic will be included in your Xcelerator where applicable."
                          matTooltipClass="tooltip1"
                          >info
                        </mat-icon>
                      </li>
                      <span></span>
                    </div>
                    <div class="widget-body">
                      <table
                        class="table table-striped table-bordered table-hover"
                      >
                        <thead>
                          <tr>
                            <th class="t1">Sub Topic</th>
                            <th class="t2">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (rb of tp.rulebooks; track rb) {
                            <tr>
                              <td class="t1">{{ rb.rbName }}</td>
                              <td class="t2">
                                <span class="rb-percent complete"
                                  >Applicable</span
                                >
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </div>
    <mat-card class="audit-detail" fxFlex="35">
      <mat-card-title class="mat-primary mat-toolbar"
        >Audit Details</mat-card-title
      >
      <mat-card-subtitle class="sub-title">
        {{ auditName }}
        @if (isDualLanguage) {
          <mat-icon
            class="monitor-icon keep-right dual"
            matTooltip="Dual Language Audit"
            matTooltipClass="tooltip2"
            >translate</mat-icon
          >
        }
        <p class="note-font">{{ facilityLocation }}<br />{{ auditDate }}</p>
        <section class="example-section">
          <h3>{{ percentage }}%</h3>
          <mat-progress-bar
            class="percentage"
            [mode]="determinate"
            [value]="percentage"
          >
          </mat-progress-bar>
        </section>
      </mat-card-subtitle>
      <mat-card-content class="large">
        @for (ac of rulebooks; track ac) {
          <div fxLayout="column" fxFill>
            <div fxLayout fxFlex>
              <div class="one" fxFlex="85" fxLayoutAlign="start start">
                <p
                  [class.highlighted]="ac.acronym === selectedAcronym"
                  (click)="onAcronymChange(ac.acronym)"
                  style="cursor: pointer"
                >
                  {{ ac.title }}
                </p>
              </div>
              <div class="two" fxFlex="15" fxLayoutAlign="start start">
                <p>{{ ac.percentage }}</p>
              </div>
            </div>
          </div>
        }
      </mat-card-content>
      <mat-card-actions id="bottomPad">
        <button
          mat-button
          class="reverse-icon-button"
          [matMenuTriggerFor]="actionMenu"
          #menuTrigger="matMenuTrigger"
          (click)="menuTrigger.openMenu()"
        >
          Actions<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <!--First level menu-->
        <mat-menu #actionMenu="matMenu">
          @if (account.userType.charAt(2) === "1") {
            <button
              mat-menu-item
              (click)="onBuild($event, 'X3.0')"
              matTooltip="Moves applicable audit statements into an Excel file."
              matTooltipClass="tooltip2"
            >
              <mat-icon aria-hidden="true" aria-label="Next">build</mat-icon
              >Build Xcelerator
            </button>
          }
          @if (account.userType.charAt(2) === "1") {
            <button
              mat-menu-item
              (click)="onBuild($event, 'C3.0')"
              matTooltip="Builds an excel list of all relevant regulatory citations included in this Template."
              matTooltipClass="tooltip2"
            >
              <mat-icon aria-hidden="true" aria-label="Next">receipt</mat-icon
              >Build RegRegister
            </button>
          }
          @if (account.userType.charAt(2) === "1") {
            <button
              mat-menu-item
              (click)="onBuild($event, 'csv')"
              matTooltip="Moves applicable audit statements into a CSV file."
              matTooltipClass="tooltip2"
            >
              <mat-icon aria-hidden="true" aria-label="Next">receipt</mat-icon
              >Build CSV
            </button>
          }
          @if (account.userType.charAt(0) === "1") {
            <button
              mat-menu-item
              (click)="onBuild($event, 'reghub')"
              matTooltip="Uploads templates & citations into RegHub to be monitored."
              matTooltipClass="tooltip2"
            >
              <mat-icon aria-hidden="true" aria-label="Next"
                >visibility</mat-icon
              >Monitor RegRegister
            </button>
          }
          @if (account.userType.charAt(2) === "1") {
            <button mat-menu-item (click)="onViewRulebooks()">
              <mat-icon aria-hidden="true" aria-label="Next">grading</mat-icon
              >View Rulebooks
            </button>
          }
          @if (
            account.companyId !== 355 &&
            getEmis().length > 0 &&
            emisid !== 11 &&
            emisid !== 20 &&
            account.userType.charAt(2) === "1"
          ) {
            <button mat-menu-item (click)="onBuild($event, emisid)">
              Build for {{ getEmis() }}
              <mat-icon class="help-info" (click)="openHelpInfo($event, 11)"
                >info</mat-icon
              >
            </button>
          }
          @if (
            account.companyId == 355 &&
            account.userType.charAt(2) === "1" &&
            account.email.indexOf("-demo") == -1
          ) {
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Benchmark Gensuite</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>ComplianceQuest</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>EHS Insight</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Enablon</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>ETQ</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Ideagen EHS</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Intelex</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Lisam</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Origami Risk</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Partner Demo</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>SBN</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Velocity</span>
            </button>
            <button mat-menu-item (click)="onBuild($event, 'no')">
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>Vector</span>
            </button>
          }
          @if (
            account.companyId == 355 &&
            account.userType.charAt(2) === "1" &&
            account.email.indexOf("-demo") !== -1 &&
            account.email.indexOf("stp-demo") === -1
          ) {
            <button
              mat-menu-item
              (click)="
                onBuild(
                  $event,
                  account.email.substring(0, account.email.indexOf('-demo'))
                )
              "
            >
              <mat-icon fontSet="material-icons-outlined"
                >cloud_download</mat-icon
              >
              <span>{{ this.getDemoBuildType(account.email) }}</span>
            </button>
          }
        </mat-menu>
      </mat-card-actions>
    </mat-card>
  </div>
} @else {
  @if (service.loading == false) {
    <div class="common-section">
      <h3>No rulebook in this template</h3>
      <p>Click 'Add/remove topics' button to add topics to the template.</p>
    </div>
  }
}
@if (service.loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
